import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PublicSite from './components/PublicSite';
import AdminDashboard from './components/AdminDashboard';

// Admin dashboard is only accessible when running locally.
// On the live Netlify site, visiting /admin just shows the public site.
const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          {isLocal && <Route path="/admin" element={<AdminDashboard />} />}
          <Route path="/*" element={<PublicSite />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
